(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Outil', Outil);

    Outil.$inject = ['$resource', 'DateUtils'];

    function Outil ($resource, DateUtils) {
        var resourceUrl =  'api/outil/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'getEnabled': {
                method: 'GET',
                isArray: true,
                url: resourceUrl + '/get-enabled'
            },
            'update': { method:'PUT' }
        });

    }
})();
